import React from 'react';
import { Link } from 'react-router-dom';
import './AnnonceCard.css';

const formatPrix = (prix) => {
  if (!prix) return 'Prix à discuter';
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(prix);
};

const formatDate = (date) => {
  const d = new Date(date);
  const now = new Date();
  const diff = Math.floor((now - d) / 86400000);
  if (diff === 0) return "Aujourd'hui";
  if (diff === 1) return 'Hier';
  if (diff < 7)  return `Il y a ${diff} jours`;
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
};

export default function AnnonceCard({ annonce }) {
  return (
    <Link to={`/annonces/${annonce.id}`} className={`annonce-card ${annonce.mise_en_avant ? 'annonce-card--vedette' : ''}`}>
      {annonce.mise_en_avant && <span className="vedette-badge">⭐ Mis en avant</span>}

      <div className="annonce-card-img">
        {annonce.photo
          ? <img src={annonce.photo} alt={annonce.titre} loading="lazy" />
          : <div className="annonce-card-noimg">
              <span style={{ fontSize: '2rem' }}>{annonce.icone || '📦'}</span>
            </div>
        }
        <span className="annonce-card-territoire">{annonce.territoire}</span>
      </div>

      <div className="annonce-card-body">
        <div className="annonce-card-cat" style={{ color: annonce.couleur }}>
          {annonce.categorie}
        </div>
        <h3 className="annonce-card-titre">{annonce.titre}</h3>
        <div className="annonce-card-prix">
          {formatPrix(annonce.prix)}
          {annonce.prix_negociable && <span className="negociable">négociable</span>}
        </div>
        <div className="annonce-card-meta">
          <span>{annonce.ville || annonce.territoire}</span>
          <span>{formatDate(annonce.created_at)}</span>
        </div>
      </div>
    </Link>
  );
}
